/**
 * Cozy nighttime sleep spots per backyard — normalized world coordinates.
 */

import type { SpawnPoint } from '@/world-prototype/types';

export interface WildlifeSleepYardConfig {
  yardId: string;
  /** Rabbit tuck-in beside vegetation. */
  rabbit: SpawnPoint;
  /** Shared frog den center. */
  frogDen: SpawnPoint;
  /** Per-frog offsets from the den center (two frogs). */
  frogOffsets: readonly [SpawnPoint, SpawnPoint];
  /** Bird tuck-in offset from the live nest anchor. */
  birdNestOffset: SpawnPoint;
}

const HUBERT: WildlifeSleepYardConfig = {
  yardId: 'hubert',
  rabbit: { x: 0.33, y: 0.548 },
  frogDen: { x: 0.205, y: 0.715 },
  frogOffsets: [
    { x: -0.014, y: -0.006 },
    { x: 0.016, y: 0.008 },
  ],
  birdNestOffset: { x: 0.006, y: 0.005 },
};

const HOLLY_SPRINGS: WildlifeSleepYardConfig = {
  yardId: 'raleigh',
  rabbit: { x: 0.265, y: 0.618 },
  frogDen: { x: 0.32, y: 0.625 },
  frogOffsets: [
    { x: -0.013, y: -0.005 },
    { x: 0.015, y: 0.007 },
  ],
  birdNestOffset: { x: 0, y: 0 },
};

const YARDS: Readonly<Record<string, WildlifeSleepYardConfig>> = {
  hubert: HUBERT,
  raleigh: HOLLY_SPRINGS,
};

export function wildlifeSleepConfigForYard(
  yardId: string | null | undefined,
): WildlifeSleepYardConfig | null {
  if (!yardId) return null;
  return YARDS[yardId] ?? null;
}

export function frogSleepTarget(
  config: WildlifeSleepYardConfig,
  frogIndex: number,
): SpawnPoint {
  const offset = config.frogOffsets[frogIndex] ?? { x: 0, y: 0 };
  return {
    x: config.frogDen.x + offset.x,
    y: config.frogDen.y + offset.y,
  };
}
